
export default function Footer() {
  return (
    <footer className="footer">
      © 2026 Directorate of Economics & Statistics,
      Government of Andhra Pradesh. All Rights Reserved.
    </footer>
  );
}